/**
 * Playground appearance. Light is the default: a bare document and an unset
 * preference both paint the studio. Only an explicit "dark" stays dark.
 */
export const THEME_KEY = "tavsin.web.theme";

export type WebTheme = "dark" | "light";

export function readStoredTheme(getItem: (key: string) => string | null): WebTheme {
  return getItem(THEME_KEY) === "dark" ? "dark" : "light";
}
